// extracted by mini-css-extract-plugin
module.exports = {"searchResults":"_3Jah1x563rzgPkY4rHiE_9","delete":"_3H6VgPGDSrXzuG2A96st_","result":"_3kaBWCsDdrn0dL-I18AKJv"};